const Line = ({ className, ...restProps }) => {
    return <div className={className} {...restProps} />;
};
export default Line;
